import React from 'react';
import { User, Headphones } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TranscriptMessage {
  speaker: 'agent' | 'customer';
  message: string;
  timestamp: string;
  feedback?: string;
}

interface TranscriptViewerProps {
  transcript: TranscriptMessage[];
  className?: string;
}

export const TranscriptViewer: React.FC<TranscriptViewerProps> = ({
  transcript,
  className
}) => {
  return (
    <div className={cn("space-y-4", className)}>
      {transcript.map((item, index) => (
        <div key={index} className="relative">
          <div className={cn(
            "flex gap-3 p-4 rounded-lg",
            item.speaker === 'agent' ? "bg-blue-50" : "bg-gray-50"
          )}>
            <div className={cn(
              "flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center",
              item.speaker === 'agent' ? "bg-blue-600 text-white" : "bg-gray-600 text-white"
            )}>
              {item.speaker === 'agent' ? (
                <Headphones className="w-4 h-4" />
              ) : (
                <User className="w-4 h-4" />
              )}
            </div>
            
            <div className="flex-1">
              <div className="flex items-baseline justify-between mb-1">
                <span className="font-medium text-gray-900">
                  {item.speaker === 'agent' ? 'Agent' : 'Customer'}
                </span>
                <span className="text-sm text-gray-500">{item.timestamp}</span>
              </div>
              
              <p className="text-gray-700">{item.message}</p>
              
              {item.feedback && (
                <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-md">
                  <p className="text-sm text-orange-800">
                    <span className="font-medium">Feedback: </span>
                    {item.feedback}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};